"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "PopoverSurface", {
    enumerable: true,
    get: function() {
        return PopoverSurface;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _usePopoverSurface = require("./usePopoverSurface");
const _renderPopoverSurface = require("./renderPopoverSurface");
const _usePopoverSurfaceStylesstyles = require("./usePopoverSurfaceStyles.styles");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const PopoverSurface = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _usePopoverSurface.usePopoverSurface_unstable)(props, ref);
    (0, _usePopoverSurfaceStylesstyles.usePopoverSurfaceStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('usePopoverSurfaceStyles_unstable')(state);
    return (0, _renderPopoverSurface.renderPopoverSurface_unstable)(state);
});
PopoverSurface.displayName = 'PopoverSurface';
